export default __webpack_public_path__ + "static/media/boina.dad34394.png";